import { render, staticRenderFns } from "./FirstAdmissionC.html?vue&type=template&id=862995e6&scoped=true&"
import script from "./FirstAdmissionC.vue?vue&type=script&lang=js&"
export * from "./FirstAdmissionC.vue?vue&type=script&lang=js&"
import style0 from "./FirstAdmissionC.scss?vue&type=style&index=0&id=862995e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862995e6",
  null
  
)

export default component.exports